export default {
  $el: 'section',
  attrs: {},
  children: [
    {
      label: 'Is there a disruption to production / loss of access to a site?',
      $formkit: 'radio',
      help: 'e.g. fire, bomb threat, flood, unauthorised occupation to site',
      if: '$incidentForms.type === Facilities',
      name: 'facilitiesProductionDisruption',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Has there been a life threatening injury?',
      $formkit: 'radio',
      if: '$incidentForms.facilitiesProductionDisruption === no',
      name: 'facilitiesLifeThreateningInjury',
      type: 'radio',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Is there a partial loss of access to a site?',
      $formkit: 'radio',
      help: 'e.g. postal options failing, unable to pay.',
      if: '$incidentForms.facilitiesLifeThreateningInjury === no',
      name: 'facilitiesPartialLossOfAccess',
      type: 'radio',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      $el: 'div',
      if: '$incidentForms.facilitiesPartialLossOfAccess === no',
      children: [
        {
          $el: 'section',
          attrs: {
            class: 'incident-details',
          },
          children: [
            {
              $el: 'h3',
              children: 'We believe that this is a low severity incident.',
            },
            {
              $el: 'p',
              children: 'Please contract the local H&S lead.',
            },
          ],
        },
      ],
    },
  ],
}
